import React from 'react';
import Icone, { NomeIcone } from '../primitivos/Icone';

/**
 * Bloco de um formulário — ícone, título e os campos (at-58, frente C).
 *
 * A etapa 1 da adesão tem **19 campos**, e a spec 03 §3 os agrupa em cinco
 * blocos ("Identificação", "Dados do Associado", "Contatos", "Regional",
 * "Endereço"). Sem essa divisão o formulário é uma coluna longa e indistinta —
 * o consultor perde o lugar ao rolar no celular.
 *
 * ⚠️ É `<section>` com `<h2>`, não `<div>` com texto em negrito: o leitor de tela
 * lista os blocos e permite pular entre eles, que é como se navega um formulário
 * longo sem enxergar.
 *
 * 📌 Serve às etapas 2 a 6 e às substituições sem mudança nenhuma — é o que a
 * tese do refactor previa (`plan-0` §4.3): a etapa 1 é
 * `AppShell + PageHeader + Stepper + FormSection×N + Field×N + FormActions`, e
 * nada disso é específico de "associado".
 */

interface PropsFormSection {
  titulo: string;
  icone: NomeIcone;
  children: React.ReactNode;
  className?: string;
}

const FormSection: React.FC<PropsFormSection> = ({ titulo, icone, children, className = '' }) => (
  <section className={className}>
    <div className="tw-mb-4 tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-superficie tw-pb-3">
      <span className="tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-brand-tint tw-text-brand">
        <Icone nome={icone} tamanho={14} />
      </span>
      <h2 className="tw-m-0 tw-text-sm tw-font-bold tw-uppercase tw-tracking-wide tw-text-texto-corpo">
        {titulo}
      </h2>
    </div>

    {children}
  </section>
);

export default FormSection;
